<template>


	<div class="board_comment">
		<div class="comment_list">
			<!--<div class="comment_total">댓글 <span>{{ commentList.length | currency }}</span></div>-->
			<ul class="dep1">

				<template v-if="commentList.length <= 0">
					<li>
						<div class="comment_empty">
							등록된 댓글이 없습니다.
						</div>
					</li>
				</template>
				<template v-else-if="commentList.length > 0">

					<li v-for="(item, index) in commentList">
						<div class="comment_box" v-if="item.depth == 1">
							<div class="info">
								<span class="name">{{ item.writerDec }}</span>
								<span class="date">{{ item.createDate | datetimeFilter }}</span>
								<template v-if="isMine(item.writerKeyDec)">
									<span><button type="button" @click="toggleUpdate(item)">수정</button></span>
									<span><button type="button" @click="doDelete(item.idx)">삭제</button></span>
								</template>
							</div>
							<div class="cmnt" v-html="item.contentHtml" style="word-break: break-word;"></div>
							<div class="reply_btn">
								<button type="button" class="btn_reply" @click="toggleInsert(item)">답글</button>
							</div>
						</div>

						<!-- 댓글 수정란 -->
						<ul class="dep2" :id="'comment-edit-' + item.idx" style="display: none;">
							<li>
								<form @submit.prevent="updateComment($event, item)">
									<div class="write_box">
										<div class="tta_wrap">
											<textarea name="" cols="30" :rows="item.contentText.split('\n').length" placeholder="댓글을 입력해 보세요" v-model="item.contentText" wrap="soft"></textarea>
										</div>
										<div class="btn_wrap">
											<button type="submit">등록</button>
										</div>
									</div>
								</form>
							</li>
						</ul>

						<!-- 대댓글 작성란 -->
						<ul class="dep2" :id="'comment-add-' + item.idx" style="display: none;">
							<li>
								<form @submit.prevent="setComment2($event, item)">
									<div class="write_box">
										<div class="tta_wrap">
											<textarea name="" id="commentWrite" cols="30" :rows="commentVO2.contentText.split('\n').length" placeholder="댓글을 입력해 보세요" v-model="commentVO2.contentText"></textarea>
										</div>
										<div class="btn_wrap">
											<button type="submit">등록</button>
										</div>
									</div>
								</form>
							</li>
						</ul>

						<!-- 대댓글 + 답글작성란 -->
						<ul class="dep2" style="display: block;" v-if="item.rows.length > 0">
							<template v-for="(row, jdx) in item.rows">
								<li>
									<div class="comment_box">
										<div class="info">
											<span class="name">{{ row.writerDec }}</span>
											<span class="date">{{ row.createDate | datetimeFilter }}</span>
											<template v-if="isMine(row.writerKeyDec)">
												<span><button type="button" @click="toggleUpdate(row)">수정</button></span>
												<span><button type="button" @click="doDelete(row.idx)">삭제</button></span>
											</template>
										</div>
										<div class="cmnt" v-html="row.contentHtml" style="word-break: break-word;"></div>
										<div class="reply_btn">
											<button type="button" class="btn_reply" @click="toggleInsert(row)">답글</button>
										</div>
									</div>
								</li>

								<!-- 대댓글 수정란 -->
								<li :id="'comment-edit-' + row.idx" style="display: none;">
									<form @submit.prevent="updateComment($event, row)">
										<div class="write_box">
											<div class="tta_wrap">
												<textarea name="" cols="30" :rows="row.contentText.split('\n').length" placeholder="댓글을 입력해 보세요" v-model="row.contentText"></textarea>
											</div>
											<div class="btn_wrap">
												<button type="submit">등록</button>
											</div>
										</div>
									</form>
								</li>

								<!-- 대대댓글 작성란 -->
								<li :id="'comment-add-' + row.idx" style="display: none;">
									<form @submit.prevent="setComment2($event, row)">
										<div class="write_box">
											<div class="tta_wrap">
												<textarea name="" cols="30" :rows="commentVO2.contentText.split('\n').length" placeholder="댓글을 입력해 보세요" v-model="commentVO2.contentText"></textarea>
											</div>
											<div class="btn_wrap">
												<button type="submit">등록</button>
											</div>
										</div>
									</form>
								</li>
							</template>
						</ul>

					</li>

				</template>

			</ul>
		</div>

		<!-- 댓글 작성란 -->
		<div class="comment_write">
			<form @submit.prevent="setComment1">
				<div class="tta_wrap">
					<textarea name="" id="commentWrite" cols="30" :rows="commentVO1.contentText.split('\n').length" placeholder="댓글을 입력해 보세요" v-model="commentVO1.contentText"></textarea>
				</div>
				<div class="btn_wrap">
					<button type="submit">등록</button>
				</div>
			</form>
		</div>
	</div>



	<!-- Comment List -->
<!--	<div class="detail-comment">

		<div class="inner">

			<div class="comment1-empty" v-if="commentList.length <= 0">
				<p>등록된 댓글이 없습니다.</p>
			</div>

			<ul class="comment1-list" v-else-if="commentList.length > 0">

				<template v-for="(item, index) in commentList">
					<li :class="{ 'my' : isMine(item.writerKeyDec), 'your' : !isMine(item.writerKeyDec)  }" >
						<div class="bubble">
							<div class="info">
								<strong class="name">{{ item.writerDec }}</strong>
								<span class="time">{{ item.createDate | datetimeFilter }}</span>
								<template v-if="isMine(item.writerKeyDec)">
									<a href="javascript:;" class="edit" @click="toggleUpdate(item)"><span class="blind">수정</span></a>
									<a href="javascript:;" class="delete" @click="doDelete(item.idx)"><span class="blind">삭제</span></a>
								</template>
							</div>
							<p class="comment" v-text="item.contentText"></p>
						</div>

						<div :id="'comment1-edit-' + item.idx" class="comment1-input" style="display: none;">
							<form @submit.prevent="updateComment($event, item)">
								<div class="inp-box">
									<textarea class="auto_resize" name="" cols="30" :rows="item.contentText.split('\n').length" placeholder="댓글을 입력해 보세요" v-model="item.contentText" style="height: max-content"></textarea>
								</div>

								<div class="btn-box">
									<button class="btn-comment" type="submit">작성</button>
								</div>
							</form>
						</div>

					</li>
				</template>

			</ul>
			<div class="comment1-input">
				<form @submit.prevent="setComment">
					<div class="inp-box">
						<textarea name="" id="commentWrite" cols="30" :rows="commentVO1.contentText.split('\n').length" placeholder="댓글을 입력해 보세요" v-model="commentVO1.contentText"></textarea>
					</div>
					<div class="btn-box">
						<button class="btn-comment" type="submit">작성</button>
					</div>
					{{ $('#commentWrite')._value }}
				</form>
			</div>
		</div>
	</div>-->

</template>

<script>
import Qs from "qs";

export default {
	name: "commentDefault",
	props: {
		bidx: Number,
	},
	data() {

		return {
			// idx: this.webUtils.getParameterInt("idx"),
			// idx: this.$route.query.idx,

			commentVO1: new this.CommentVO( this.getSessionProc() ),
			commentVO2: new this.CommentVO( this.getSessionProc() ),
			commentList: [],
		}
	},
	created() {

		// alert( this.APIs.BASE_URL )

	},
	mounted() {

		if ( this.bidx > 0 ) {
			this.getCommentList();
		}

	},
	methods: {

		getCommentList() {

			this.$eventBus.$emit("startProgress", 2)
			this.axiosCaller.get( this,  this.APIs.BOARD_COMMENTS + "/tree/" + this.bidx, {
				isSingle: true
			}, (res) => {
				var result = res.data;
				this.commentList = result.list

				this.$eventBus.$emit("doneProgress", 2)
			})

		},

		async setComment1(e) {

			e.preventDefault()

			await this.requireLogin(this);

			if ( this.commentVO1.contentText.trim().length <= 0 ) {
				this.swalUtils.gritter("댓글의 내용이 없습니다.", "댓글 내용을 입력해주세요.", "info", 1000)
				return
			}

			this.commentVO1.bidx = this.bidx
			this.commentVO1.writerKey = this.getSessionProc().coEmailId;
			this.commentVO1.writer = this.getSessionProc().nickName;
			let temp = this.commentVO1;

			this.$eventBus.$emit("startProgress")
			this.axiosCaller.post( this, this.APIs.BOARD_COMMENTS + "/" + this.bidx, temp, (res) => {

				this.$eventBus.$emit("doneProgress")
				const result = res.data;
				temp = result.commentVO
				this.commentVO1 = new this.CommentVO( this.getSessionProc() );
				if ( result.status === "ok" ) {
					this.swalUtils.gritter("Success", "댓글이 저장 되었습니다", "success", 1000)
					this.getCommentList()
				}
			})

		},

		async setComment2(e) {

			e.preventDefault()

			await this.requireLogin(this);

			if ( this.commentVO2.contentText.trim().length <= 0 ) {
				this.swalUtils.gritter("댓글의 내용이 없습니다.", "댓글 내용을 입력해주세요.", "info", 1000)
				return
			}

			this.commentVO2.bidx = this.bidx
			this.commentVO2.writerKey = this.getSessionProc().coEmailId;
			this.commentVO2.writer = this.getSessionProc().nickName;
			let temp = this.commentVO2;

			this.$eventBus.$emit("startProgress")
			this.axiosCaller.post( this, this.APIs.BOARD_COMMENTS + "/" + this.bidx, temp, (res) => {

				this.$eventBus.$emit("doneProgress")
				const result = res.data;
				temp = result.commentVO;
				this.commentVO2 = new this.CommentVO( this.getSessionProc() );
				if ( result.status === "ok" ) {
					this.swalUtils.gritter("Success", "댓글이 저장 되었습니다", "success", 1000)
					this.toggleInsert({
						idx: temp.pidx
					});
					this.getCommentList()
				}
			})

		},


		updateComment (e, _comment) {

			e.preventDefault()
			console.log(_comment)
			this.axiosCaller.patch( this, this.APIs.BOARD_COMMENTS + "/", {
				idx: _comment.idx,
				contentText: _comment.contentText,
			}, (res) => {
				const result = res.data
				this.toggleUpdate(_comment);
				this.getCommentList()
			})
		},




		toggleInsert( _item ) {
			this.commentVO2 = new this.CommentVO( this.getSessionProc() );
			this.commentVO2.pidx = _item.idx;
			const display = document.querySelector('#comment-add-' + _item.idx).style.display;
			if ( display === "none" ) {
				document.querySelector('#comment-add-' + _item.idx).style.display = "block";
			} else {
				document.querySelector('#comment-add-' + _item.idx).style.display = "none";
			}
		},


		toggleUpdate( _item ) {
			const display = document.querySelector('#comment-edit-' + _item.idx).style.display;
			if ( display === "none" ) {
				document.querySelector('#comment-edit-' + _item.idx).style.display = "block";
			} else {
				document.querySelector('#comment-edit-' + _item.idx).style.display = "none";
			}
		},



		doDelete ( _idx ) {

			const self = this
			this.swalUtils.fire("삭제하시겠습니까?", "회원님이 작성한 댓글이 삭제됩니다.", "error", true)
				.then((result) => {

					if ( result.isConfirmed ) {
						this.axiosCaller.delete( this, this.APIs.BOARD_COMMENTS + "/" + _idx, {}, (res) => {
							const result = res.data
							if ( result.status === "ok" ) {
								self.getCommentList()
							}
						})
					}

				})

		},
	},
	watch: {

		'commentVO1.contentText': async function (newVal) {

			if ( newVal.length > 0 && !this.isLogin() ) {

				console.log( "NO LOGIN" )
				await this.requireLogin(this);

				/*this.swalUtils.fire("로그인 후 사용하실 수 있습니다.", "확인 버튼을 누르시면 로그인 페이지로 이동합니다.", "info", null, true)
					.then((result) => {
						if ( result.isConfirmed ) {

							let temp = location.pathname + "?" + Qs.stringify( this.$route.query )
							location.href = "/member/login?referrer=" + encodeURIComponent(temp);
						}
					})*/
			}

		},

		/*'bidx': function (newVal) {

			if (newVal > 0) {
				this.getCommentList();
			}

		},*/
	}
}
</script>

<style scoped>

</style>
